/**
 * Trigger a short haptic on mobile devices that support it.
 * Silently no-ops on desktop, if haptics are blocked, or when the user has
 * turned "Sound effects" off in Settings (biscuit.sound_effects === "false").
 *
 * Variants:
 *   tap     — light single buzz, default for selects/toggles
 *   success — celebratory tri-pulse for completed actions
 *   warning — medium double-buzz for "are you sure?" prompts (e.g. arm-to-delete)
 *   error   — heavy triple-buzz for failures or destructive confirms
 */
export function haptic(kind: "tap" | "success" | "warning" | "error" = "tap"): void {
  if (typeof navigator === "undefined" || !("vibrate" in navigator)) return
  if (typeof localStorage !== "undefined" && localStorage.getItem("biscuit.sound_effects") === "false") return
  try {
    if (kind === "tap") navigator.vibrate(8)
    else if (kind === "success") navigator.vibrate([10, 40, 10])
    else if (kind === "warning") navigator.vibrate([18, 60, 18])
    else if (kind === "error") navigator.vibrate([30, 30, 30])
  } catch {
    // some browsers throw if user hasn't interacted yet
  }
}
